module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa1a9f53942284b3bdc02e9e69cb181e7.a1a9f539.png";